import type { IClientInfo } from 'src/interfaces';

export const mapDeceasedDataToApi = ({ decedent, yearOfBirth, yearOfDeath }: IClientInfo) => ({
  fullname: decedent,
  ...(yearOfBirth && { dob: { year: parseInt(yearOfBirth, 10) } }),
  ...(yearOfDeath && { dod: { year: parseInt(yearOfDeath, 10) } }),
});
